import React, { useEffect, useState } from "react";
import { Grid, Button, Alert, Form } from "tabler-react";
import { ContentTextProps, blackListProps } from "../../types";
import ServerSidePagination from "../../components/pagination/serverSidePagination";
import TableCard from "../../components/tableCard";
import TableModal from "./tableModal";
import ReactModal from "react-modal";

import "./style.css";
import { alertCustomStyles } from "../../helpers";

const AutomationCategories = ({
  data,
  loading,
  createAutomationCategory,
  deleteCategory,
  updateCategory,
  onPageNumberChange,
}: any): JSX.Element => {
  const [categoryList, setCategoryList] = useState<Array<blackListProps>>([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [editCategory, setEditCategory] = useState<any>(false);
  const [total, setTotal] = useState(0);
  const [editField, setEditField] = useState<any>(null);

  const handleModal = () => {
    if (showModal) {
      setEditField(null);
      setErrorMessage("");
    }
    setShowModal(!showModal);
  };

  const handleSave = async ({ ...rest }) => {
    const { name } = rest;
    if (editCategory) {
    } else {
      const res = await createAutomationCategory({
        variables: { settings: { name: name } },
      });
      if (
        res.data.HexomaticAdminOps &&
        !res.data.HexomaticAdminOps.createAutomationCategory
      ) {
        handleModal();
        return;
      }
      const { error_code } =
        res.data.HexomaticAdminOps.createAutomationCategory;
      if (error_code) {
        setErrorMessage(error_code);
        return;
      }
    }
    return true;
  };

  const onDelete = async (id: number) => {
    let deleteConfirm = confirm(
      `Are you sure you want to delete automation category with ID: ${id}`
    );
    if (!deleteConfirm) return;
    const res = await deleteCategory({
      variables: { settings: { category_id: id } },
    });
    if (
      res.data.HexomaticAdminOps &&
      !res.data.HexomaticAdminOps.deleteAutomationCategory
    ) {
      setCategoryList(categoryList.filter((item) => item.id !== id));
      return;
    }
    const { error_code } = res.data.HexomaticAdminOps.deleteAutomationCategory;
    if (error_code) {
      setErrorMessage(error_code);
      return;
    }
  };

  const onUpdata = async ({ category_id, name }) => {
    const res = await updateCategory({
      variables: { settings: { category_id, name } },
    });
    handleModal();
    if (
      res.data.HexomaticAdminOps &&
      !res.data.HexomaticAdminOps.deleteAutomationCategory
    ) {
      const newCategories = categoryList.map((item) => {
        if (item.id === category_id) {
          return { ...item, name: name };
        }
        return item;
      });
      setCategoryList(newCategories);
      return;
    }
    const { error_code } = res.data.HexomaticAdminOps.updateAutomationCategory;
    if (error_code) {
      setErrorMessage(error_code);
      return;
    }
  };

  const tableData = {
    tData:
      categoryList &&
      categoryList.map((item: ContentTextProps) => ({
        id: item.id,
        name: item.name,
        Action: (
          <Button.List>
            <Button
              color="primary"
              icon="edit"
              onClick={() => {
                setEditField(item);
                setShowModal(true);
              }}
            />
            <Button
              color="danger"
              icon="trash"
              onClick={() => onDelete(item.id)}
            />
          </Button.List>
        ),
      })),
  };

  useEffect(() => {
    if (
      data &&
      data.HexomaticAdmin &&
      data.HexomaticAdmin.getAutomationCategories.categories
    ) {
      setDataLoading(loading);
      setCategoryList(data.HexomaticAdmin.getAutomationCategories.categories);
      // setTotal(data.EmailBlackList.adminGetMany.total)
    }
  }, [data]);

  return (
    <Grid.Row cards deck>
      <TableModal
        handleModal={handleModal}
        showModal={showModal}
        onUpdate={onUpdata}
        onSave={handleSave}
        editField={editField}
        errorMessage={errorMessage}
      />

      <ReactModal isOpen={!!errorMessage} style={alertCustomStyles}>
        {errorMessage ? <Alert type="danger">{errorMessage}</Alert> : null}
        <Button
          className=""
          onClick={() => setErrorMessage("")}
          color="primary"
        >
          OK
        </Button>
      </ReactModal>
      <div className="col-12 col-md-1 col-xs-6">
        <Button className="" onClick={() => setShowModal(true)} color="primary">
          Create
        </Button>
        <br />
      </div>
      <Grid.Col md={9}></Grid.Col>
      <div className="col-12 col-md-2 col-xs-6">
        <Alert type="info">Result Count - {total || categoryList.length}</Alert>
      </div>
      <div className="black-list-table-pagination">
        <ServerSidePagination
          data={categoryList}
          total={total}
          onPageNum={onPageNumberChange}
        >
          <TableCard
            loading={dataLoading}
            data={categoryList}
            tableData={tableData}
          />
        </ServerSidePagination>
      </div>

      {categoryList.length ? (
        <div className="col-12 col-md-2 col-xs-12 offset-md-10">
          <Alert type="info">
            Result Count - {total || categoryList.length}
          </Alert>
        </div>
      ) : null}
    </Grid.Row>
  );
};

export default AutomationCategories;
